import { render, staticRenderFns } from "./DDNSStatus.vue?vue&type=template&id=6deb8a2d&scoped=true&"
import script from "./DDNSStatus.vue?vue&type=script&lang=js&"
export * from "./DDNSStatus.vue?vue&type=script&lang=js&"
import style0 from "./DDNSStatus.vue?vue&type=style&index=0&id=6deb8a2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deb8a2d",
  null
  
)

export default component.exports